import PanelForm from './../panel/Form'
import React, {useEffect, useState} from "react";
import {AppApi} from "../AppApi";
import styles from './Form.module.css';

function Form() {

    const [images, setImages] = useState();

    function getImages() {
        AppApi.pub.getDatenschutz()
            .then(response => {
                setImages(response.data)
            })
            .catch(console.log)
    }

    useEffect(() => {
        if(images == null){
            getImages()
        }
    }, [images]);

    return (
      <div className="wrapper" style={{padding: '0 10px 0 10px'}}>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <PanelForm>



          </PanelForm>

          {images?.map(image => (
              <img src={image} className={styles.root}/>
          ))}
      </div>
    );
}

export default Form;
